import React from 'react';

type Props = {
  episodeNum: number;
  seasonNum: number;
};

export const SeasonEpisodeNumber: React.FC<Props> = ({ episodeNum, seasonNum }) => {
  return <span aria-label="season and episode number">{`S${seasonNum}:Ep${episodeNum}`}</span>;
};
